import React, { useState, useEffect } from "react";
import Modal from "components/modal";

const PromotionFormModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  initialPromotion, 
  isEditing,
  loading 
}) => {
  const [promotion, setPromotion] = useState({
    name_promotion: "",
    annee_promotion: new Date().getFullYear()
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && initialPromotion) {
      setPromotion({
        name_promotion: initialPromotion.name_promotion || "",
        annee_promotion: initialPromotion.annee_promotion || new Date().getFullYear(),
      });
      setValidationErrors({});
    }
  }, [isOpen, initialPromotion]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPromotion({
      ...promotion,
      [name]: name === "annee_promotion" ? parseInt(value, 10) : value,
    });

    if (validationErrors[name]) {
      setValidationErrors({
        ...validationErrors,
        [name]: null,
      });
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!promotion.name_promotion.trim()) {
      errors.name_promotion = "Le nom de la promotion est requis";
    }

    if (!promotion.annee_promotion) {
      errors.annee_promotion = "L'année de la promotion est requise";
    } else if (isNaN(promotion.annee_promotion)) {
      errors.annee_promotion = "L'année doit être un nombre";
    } else if (
      promotion.annee_promotion < 2000 ||
      promotion.annee_promotion > 2100
    ) {
      errors.annee_promotion = "L'année doit être comprise entre 2000 et 2100";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setSubmitting(true);
    
    const result = await onSubmit({
      name_promotion: promotion.name_promotion,
      annee_promotion: promotion.annee_promotion,
    });
    
    if (!result.success) {
      setValidationErrors(result.errors || {});
    }
    
    setSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="md">
      <div className="text-center sm:text-left">
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-800">
            {isEditing
              ? "Modifier la promotion"
              : "Créer une nouvelle promotion"}
          </h3>
          <div className="h-1 w-12 bg-[#57A863] mt-2 rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="name_promotion"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Nom de la promotion
            </label>
            <input
              type="text"
              name="name_promotion"
              id="name_promotion"
              value={promotion.name_promotion}
              onChange={handleInputChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
            />
            {validationErrors.name_promotion && (
              <p className="mt-1.5 text-sm text-red-600">
                {validationErrors.name_promotion}
              </p>
            )}
          </div>

          <div>
            <label
              htmlFor="annee_promotion"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Année de la promotion
            </label>
            <input
              type="number"
              name="annee_promotion"
              id="annee_promotion"
              value={promotion.annee_promotion}
              onChange={handleInputChange}
              min="2000"
              max="2100"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
            />
            {validationErrors.annee_promotion && (
              <p className="mt-1.5 text-sm text-red-600">
                {validationErrors.annee_promotion}
              </p>
            )}
          </div>

          {validationErrors.general && (
            <div className="rounded-md bg-red-50 p-3 border border-red-200">
              <p className="text-sm text-red-600">
                {validationErrors.general}
              </p>
            </div>
          )}

          <div className="mt-8 flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
              onClick={onClose}
              disabled={submitting || loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-md bg-[#57A863] text-white hover:bg-[#4c9657] transition-colors shadow-sm"
              disabled={submitting || loading}
            >
              {(submitting || loading) ? (
                <span className="flex items-center">
                  <svg
                    className="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Chargement...
                </span>
              ) : isEditing ? (
                "Mettre à jour"
              ) : (
                "Créer"
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default PromotionFormModal;